import { cn } from "@/utils/theme";
import { Avatar, AvatarFallback, Icon } from "@elaniintc/goes-design-system";
import type { ComponentProps } from "react";
import { Skeleton } from "./skeleton";

interface SectionCardProps {
  title: string;
  description: string;
  lastUpdated?: string;
  iconName?: string;
  iconType?: "fas" | "far";
  className?: string;
  isLoadingDate?: boolean;
}

const SectionCard = ({
  title,
  description,
  lastUpdated,
  iconName = "bell",
  iconType = "fas",
  className,
  isLoadingDate = true,
  ...props
}: SectionCardProps & Omit<ComponentProps<"div">, "title">) => {
  return (
    <div
      className={cn(
        "flex w-full md:w-[273px] p-3 px-4 flex-col items-start gap-2 rounded-lg border-[0.5px] border-neutral bg-neutral-object cursor-pointer transition-shadow shadow-neutral-xs hover:shadow-neutral-md",
        className,
      )}
      {...props}
    >
      <div className="flex flex-col items-start gap-2 self-stretch">
        <div className="flex items-start self-stretch">
          <Avatar size="xl" shape="circle">
            <AvatarFallback color="action" type="icon" shape="circle">
              <Icon type={iconType} name={iconName} size="sm" />
            </AvatarFallback>
          </Avatar>
        </div>
        <div className="flex flex-col items-start gap-0.5 self-stretch">
          <h3 className="self-stretch text-heading font-semibold text-base leading-7">
            {title}
          </h3>
          <p className="self-stretch text-body-quiet text-sm leading-6">
            {description}
          </p>
        </div>
      </div>

      {isLoadingDate ? (
        <Skeleton className="w-full h-3.5" />
      ) : (
        <>
          {lastUpdated ? (
            <div className="self-stretch text-body-quiet text-xs leading-5 tracking-[0.24px]">
              Actualizado: {lastUpdated || "No hay datos"}
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

export default SectionCard;
